<template>
	<div v-if="componentRow.length > 0">
		<div class="row comp_row">
			<div class="col-12" v-for="componentName in componentRow">
				<component-logic :program-guide="programGuide" :component-name="componentName"></component-logic>
			</div>
		</div>
	</div>
</template>

<script>
	import ComponentLogic from './ComponentLogic'

	export default {
	  name: 'component-row',
	  props: ['componentRow', 'programGuide'],
	  components: {
	  	ComponentLogic
	  }
	}
</script>

<style scoped>
	.comp_row {
    margin: auto;
  }
<style>


// WEBPACK FOOTER //
// src/app/dashboard/components/ComponentRow.vue